<template>
  <el-dialog
      title="产品价格申请"
      :visible.sync="dialogVisible"
      top="2vh"
      width="800px"
      append-to-body
      @close="closeDialog">
    <div style="height: 25px;">
      <el-button
          v-if="orderType"
          type="primary"
          size="mini"
          style="float: right; margin: 0 10px 5px 0"
          :icon="order ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
          @click="changeOrder">
        {{order ? "升序" : "降序"}}
      </el-button>
      <el-radio-group v-model="orderType" style="float: right; margin: 5px 20px 0 0;">
        <el-radio :label="1">客户名称</el-radio>
        <el-radio :label="2">价格</el-radio>
      </el-radio-group>
    </div>
    <el-table :data="tableData" height="calc(100vh - 25vh)">
      <el-table-column property="customerName" label="客户名称"/>
      <el-table-column property="employeeName" label="销售员" width="100"/>
      <el-table-column property="price" width="100" label="申请价格"/>
      <el-table-column label="审批价格" width="150">
        <template slot-scope="scope">
          <div>营销中心：{{scope.row.approve1Price}}</div>
          <div>营销总监：{{scope.row.approve2Price}}</div>
          <div>总经理：{{scope.row.approve3Price}}</div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  export default {
    name:"PriceApply",
    data() {
      return {
        id: 0,
        materialId: 0,
        orderType: 1,
        dialogVisible: false,
        customerNameOrder: false,
        order: false,
        priceOrder: false,
        tableData:[],
      };
    },
    methods: {
      open(id, materialId) {
        this.dialogVisible = true;
        this.id = id;
        this.materialId = materialId;
        if (id > 0) {
          this.getList();
        }
      },
      getList() {
        let params = {
          "orderType": this.orderType,
          "priceOrder": this.priceOrder,
          "customerNameOrder": this.customerNameOrder,
        };
        this.$http
          .get("basic", `material_prices/ba/${this.materialId}/${this.id}`, params)
          .then(resp => {
            this.tableData = resp;
          });
      },
      changeOrder() {
        if (this.order) {
          this.order = false;
          this.priceOrder = false;
          this.customerNameOrder = false;
        } else {
          this.order = true;
          this.priceOrder = true;
          this.customerNameOrder = true;
        }
        this.getList();
      },
      closeDialog() {
        this.orderType = 1;
        this.order = false;
        this.priceOrder = false;
        this.customerNameOrder = false;
      },
    },
  };
</script>

<style scoped>

</style>
